module.exports = __webpack_public_path__ + "static/media/Questions-41-50.1591297e.png";